import React from 'react';
import './EnhancedTestimonials.css';

const EnhancedTestimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Priya Sharma',
      role: 'Student Visa Approved',
      location: 'Dublin',
      rating: 5,
      avatar: '👩‍🎓',
      quote: 'I was checking the immigration website 5 times a day. Irish Visa Tracker sent me an email at 6:02 AM the moment my approval was published. Best ₹99 I\'ve ever spent.',
      highlight: 'Got instant notification within 2 minutes'
    },
    {
      id: 2,
      name: 'Rahul Kumar',
      role: 'Work Permit Approved',
      location: 'Cork',
      rating: 5,
      avatar: '👨‍💼',
      quote: 'Stopped wasting time refreshing pages multiple times daily. The web push notification woke me up at 6 AM with the good news. Absolutely worth it!',
      highlight: 'Saved hours of manual checking'
    },
    {
      id: 3,
      name: 'Anjali Patel',
      role: 'Family Visa Approved',
      location: 'Galway',
      rating: 5,
      avatar: '👩‍👧',
      quote: 'The processing time estimator gave me peace of mind during the wait. When my decision came, I was the first in my family to know thanks to instant alerts.',
      highlight: 'Peace of mind throughout the process'
    }
  ];

  return (
    <div className="enhanced-testimonials-section">
      <div className="testimonials-header">
        <h2 id="testimonials-title">Real Stories from Real People</h2>
        <p className="testimonials-subtitle">
          Personal experiences shared by visa applicants who used our alerts and planning tools.
        </p>
      </div>

      <div className="testimonials-grid">
        {testimonials.map((testimonial) => (
          <div key={testimonial.id} className="testimonial-card">
            <div className="testimonial-header-section">
              <div className="testimonial-avatar">{testimonial.avatar}</div>
              <div className="testimonial-info">
                <div className="testimonial-name">{testimonial.name}</div>
                <div className="testimonial-role">{testimonial.role} • {testimonial.location}</div>
                <div className="testimonial-rating">
                  {Array.from({ length: testimonial.rating }).map((_, i) => (
                    <span key={i} className="star">⭐</span>
                  ))}
                </div>
              </div>
            </div>

            <div className="testimonial-quote">
              <span className="quote-icon">"</span>
              {testimonial.quote}
              <span className="quote-icon">"</span>
            </div>

            <div className="testimonial-highlight">
              <span className="highlight-icon">💡</span>
              {testimonial.highlight}
            </div>
          </div>
        ))}
      </div>

      <div className="testimonials-cta">
        <p className="testimonials-footer-text">
          Individual experiences are not guarantees. Alert timing depends on official publication, processing, and provider delivery.
          One quote mentions the ₹99 price shown in the archived page; the current premium price is ₹349.
        </p>
      </div>
    </div>
  );
};

export default EnhancedTestimonials;
